"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
const util_1 = require("util");
const winston_1 = __importDefault(require("winston"));
const Utility_1 = require("./Utility");
const Labels_1 = require("./Labels");
const RequestContext_1 = require("./RequestContext");
class ConsoleLogger {
    constructor(loggerLevel) {
        this.MAX_DEPTH = 5;
        this.logger = winston_1.default.createLogger({
            format: winston_1.default.format.combine(winston_1.default.format.colorize(), winston_1.default.format.timestamp({
                format: 'YYYY-MM-DD HH:mm:ss',
            }), winston_1.default.format.printf((msg) => `${msg.timestamp} [${msg.level}] ${msg.message}`)),
            transports: [new winston_1.default.transports.Console()],
            level: loggerLevel.toString(),
        });
    }
    setLevel(loggerLevel) {
        this.logger.level = loggerLevel.toString();
    }
    error(message, ...optionalParams) {
        this.logger.error(this.formatMessage(message, optionalParams, {
            showHidden: true,
        }));
    }
    warn(message, ...optionalParams) {
        this.logger.warn(this.formatMessage(message, optionalParams));
    }
    info(message, ...optionalParams) {
        this.logger.info(this.formatMessage(message, optionalParams));
    }
    debug(message, ...optionalParams) {
        this.logger.debug(this.formatMessage(message, optionalParams));
    }
    verbose(message, ...optionalParams) {
        this.logger.verbose(this.formatMessage(message, optionalParams));
    }
    silly(message, ...optionalParams) {
        this.logger.silly(this.formatMessage(message, optionalParams));
    }
    formatMessage(message, optionalParams, options) {
        let msgArray = [];
        // inject request context data if available
        const requestId = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.RequestId);
        if (requestId) {
            msgArray.push(`requestId(${requestId})`);
        }
        const correlationId = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.CorrelationId);
        if (correlationId && correlationId !== requestId) {
            msgArray.push(`correlationId(${correlationId})`);
        }
        const decodedToken = RequestContext_1.RequestContext.store()?.get(Labels_1.Labels.Authorization);
        if (decodedToken) {
            const principalId = Utility_1.Utility.getPrincipal(decodedToken);
            msgArray.push(`principalId(${principalId})`);
        }
        msgArray.push(this.format(message, options));
        const formattedParams = optionalParams.map((param) => {
            return this.format(param, options);
        });
        msgArray = msgArray.concat(formattedParams);
        return msgArray.join(' ');
    }
    format(message, options) {
        let arg = message;
        if (message instanceof Error) {
            arg = Utility_1.Utility.enumerableErrors(message);
        }
        const inspectOptions = {
            colors: true,
            depth: this.MAX_DEPTH,
            ...options,
        };
        return util_1.inspect(arg, inspectOptions);
    }
}
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=ConsoleLogger.js.map